import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-abort-page',
  templateUrl: './abort-page.component.html',
  styleUrls: ['./abort-page.component.scss']
})
export class AbortPageComponent implements OnInit {

  @Output() continueButtonClick = new EventEmitter<any>();
  @Output() closeDepositFlowButtonCLick = new EventEmitter<any>();
  constructor() { }

  ngOnInit(): void {
  }
  continueDepost(){
    this.continueButtonClick.emit(true);
  }
  closeDepositFlow(){
   this.closeDepositFlowButtonCLick.emit(true);
  }
}
